import {useContext, useEffect, useState} from 'react'
import Modal, {ModalBody, ModalHeader} from '../../common/Modal'
import {PromotedBranchContext} from '../context/context'
import {getRequest, postRequest} from '../../../services/base'
import {Refresh} from '@styled-icons/boxicons-regular/Refresh'

import CheckBox from '../../common/CheckBox'
import RadioButton from '../../common/RadioButton'
import InputText from '../../common/InputText'
import Button from '../../common/Button'
import Tooltip from '../../common/tooltip'
import useDebouncedValue from '../../../utils/common_function'
import NoRecordsFound from '../../common/NoRecordsFound'
import {CheckboxMinus, CheckCircle, Save} from '@styled-icons/boxicons-solid'
import {NavContext} from '../../../context/global_context'
import {ProgresSpinner} from '../../common/ProgresSpinner'
import {Sad} from '@styled-icons/boxicons-regular'
import {PUSH_TO_GIT} from '../../../constants/permission'

const SelectFileToPromote = ({ getActiveBranchDetails }) => {
  const [state, dispatch] = useContext(PromotedBranchContext)
  const [navState, navDispatch] = useContext(NavContext)

  const [section, setSection] = useState(null)
  const [sectionData, setSectionData] = useState([])
  const [searchValue, setSearchValue] = useState(null)
  const [filteredData, setFilteredData] = useState([])
  const debouncedToSearchValue = useDebouncedValue(searchValue, 500)
  const [promotedFiles, setPromotedFiles] = useState([])
  const [includePn, setIncludePn] = useState(false)

  const [promotedFolders, setPromotedFolders] = useState({
    connector_views: [],
    power_distribution: [],
    vehicle_views: [],
    visual_aid: [],
    device_layout: [],
  })
  const [promotedCustomerFiles, setPromotedCustomerFiles] = useState([])

  const [selectAll, setSelectAll] = useState(false)
  const [isReview, setReview] = useState(false)
  const [responseData, setResponseData] = useState([])
  const [syncToGit, setSyncToGit] = useState(false)

  useEffect(() => {
    if (state?.showFileSelection) {
      getMakeModalFileDetails()
    }
  }, [state?.showFileSelection])

  const getMakeModalFileDetails = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Loading data for selected make model...',
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(
      `/api/promote_changes/vehicle-details/${state?.selectedVehicle?.vehicle_id}/`
    )
    dispatch({ type: 'promote_files_data', data: res?.data })

    if (!res?.data?.make_model_exists) {
      setPromotedCustomerFiles([...Object.keys(res?.data?.customer_files)])
    }
    setIncludePn(res?.data?.include_pn)

    selectDefaultSavedFiles(res.data)

    navDispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  useEffect(() => {
    if (searchValue) {
      setFilteredData(
        sectionData.filter((item) =>
          item.toLowerCase().includes(searchValue?.toLowerCase())
        )
      )
    } else {
      setFilteredData([...sectionData])
    }
  }, [sectionData, debouncedToSearchValue])

  const selectDefaultSavedFiles = (responseData) => {
    let tempPromotedFolders = { ...promotedFolders }

    let tempPromotedCustomerFiles = [...promotedCustomerFiles]

    let tempPromotedFiles = [...promotedFiles]

    Object.keys(responseData?.customer_files).map(
      (customer_file_key, customer_file_idx) => {
        if (responseData?.customer_files?.[customer_file_key]?.is_exists) {
          tempPromotedCustomerFiles.push(customer_file_key)
        }
      }
    )
    setPromotedCustomerFiles(tempPromotedCustomerFiles)

    Object.keys(responseData?.files).map((file_key, file_idx) => {
      if (responseData?.files?.[file_key]?.is_exists) {
        tempPromotedFiles.push(file_key)
      }
    })
    setPromotedFiles(tempPromotedFiles)

    Object.keys(responseData?.folder_data).map((folder_key, folder_idx) => {
      responseData?.folder_data?.[folder_key].map(
        (folder_dt, folder_dt_idx) => {
          tempPromotedFolders[folder_key].push(folder_dt.file_name)
        }
      )
    })
    setPromotedFolders(tempPromotedFolders)
  }

  const selectUnSelectFiles = (select, file_name, section_name = null) => {
    if (Object.keys(promotedFolders).includes(section_name)) {
      let tempPromotedFolders = { ...promotedFolders }

      let tempIndex = tempPromotedFolders?.[section_name]?.indexOf(file_name)

      if (select) {
        tempPromotedFolders?.[section_name].push(file_name)
      } else {
        tempPromotedFolders?.[section_name].splice(tempIndex, 1)
      }

      setPromotedFolders(tempPromotedFolders)
    } else if (section_name === 'customer_data') {
      let tempPromotedCustomerFiles = [...promotedCustomerFiles]

      let tempIndex = tempPromotedCustomerFiles?.indexOf(file_name)

      if (select) {
        tempPromotedCustomerFiles?.push(file_name)
      } else {
        tempPromotedCustomerFiles?.splice(tempIndex, 1)
      }

      setPromotedCustomerFiles(tempPromotedCustomerFiles)
    } else {
      let tempPromotedFiles = [...promotedFiles]

      let tempIndex = tempPromotedFiles?.indexOf(file_name)

      if (select) {
        tempPromotedFiles?.push(file_name)
      } else {
        tempPromotedFiles?.splice(tempIndex, 1)
      }

      setPromotedFiles(tempPromotedFiles)
    }
  }

  const selectUnSelectSection = (key, is_checked) => {
    setSelectAll(false)
    if (is_checked === false) {
      setSection(key)
      setSectionData([...state?.promoteFilesData?.section_data?.[key]])
    } else {
      if (key === section || section === null) {
        setSection(null)
        setSectionData([])
      } else {
        setSection(key)
        setSectionData([...state?.promoteFilesData?.section_data?.[key]])
      }
    }
  }

  const selectAllValues = (is_checked) => {
    let tempPromotedFolders = { ...promotedFolders }
    if (is_checked === true) {
      tempPromotedFolders[section] = sectionData
    } else {
      tempPromotedFolders[section] = []
    }
    setPromotedFolders({ ...tempPromotedFolders })
  }

  const submitReviewedData = async () => {
    setReview(false)
    if (
      window.confirm(
        `Are you sure want to submit reviewd files, Make sure you have deleted trashed items before doing this.`
      ) === true
    ) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Promoting selected data ...',
          showLoader: true,
        },
        notification: {},
      })

      let payload = {
        promoted_files: promotedFiles,
        promoted_folders: promotedFolders,
        sync_to_server: syncToGit,
        customer_files: promotedCustomerFiles,
        include_pn: includePn,
      }
      let res = await postRequest(
        `/api/promote_changes/files-folder/submit/${state?.selectedVehicle?.vehicle_id}/`,
        payload
      )
      if (res?.status) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'File promoted, Please check logs',
          },
        })
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: 'Failed to upload files.',
          },
        })
      }
      setResponseData(res)
      setPromotedFiles([])
      setPromotedFolders({
        connector_views: [],
        power_distribution: [],
        vehicle_views: [],
        visual_aid: [],
      })
      setSectionData([])
      setSection(null)
      dispatch({ type: 'promote_files_data', data: [] })
      setReview(false)
      setSyncToGit(false)
      getActiveBranchDetails()
      dispatch({
        type: 'show_hide_file_selection_popup',
        data: false,
        selectedVehicle: null,
        showVehicleModal: false,
        selectedFiles: [],
      })
    }
  }

  const clickToReview = () => {
    setReview(true)
    setSelectAll(false)
    let folderKey = Object.keys(promotedFolders)?.find(
      (key) => promotedFolders?.[key]?.length > 0
    )
    if (folderKey) {
      setSection(folderKey)
      setSectionData(promotedFolders[folderKey])
    } else {
      setSection(null)
      setSectionData([])
    }
  }

  return (
    <Modal
      onClose={() => {
        dispatch({
          type: 'show_hide_file_selection_popup',
          data: false,
          selectedVehicle: {},
          showVehicleModal: false,
          selectedFiles: {},
        })
      }}
      show={state?.showFileSelection}
      size={`w-full`}
    >
      <ModalHeader className={'text-white'}>
        <div className="flex items-center text-base justify-between">
          <div className="w-full">
            {responseData?.data?.upload_status ? (
              <div>We are processing files</div>
            ) : (
              <>
                {isReview
                  ? `Review and Submit files for `
                  : `Select files to update for `}
                {state?.selectedVehicle?.name}
              </>
            )}
          </div>
          {!responseData?.data?.upload_status && (
            <span className="cursor-pointer">
              <Refresh
                onClick={() => {
                  getMakeModalFileDetails()
                }}
                size={'2rem'}
              />
            </span>
          )}
        </div>
      </ModalHeader>
      {state?.promoteFilesData?.missing_files?.length > 0 ? (
        <ModalBody>
          <div className="text-white text-center">
            <Sad size={'4rem'} />
            <div>Oops! You can't push at these moment</div>
            <div className="text-lg text-orange-500">
              {state?.promoteFilesData?.missing_files.join(', ')}
            </div>
            <div> These are missing files in selected make model.</div>
          </div>
        </ModalBody>
      ) : state?.promoteFilesData?.is_processing ? (
        <ModalBody>
          <div>
            <div className="text-white flex items-center justify-content-center text-center">
              <ProgresSpinner
                caption={`Files syncing in progress so you cannot perform any action for this make model`}
              />
            </div>{' '}
          </div>
        </ModalBody>
      ) : responseData?.data?.upload_status ? (
        <ModalBody>
          <div className="text-center">
            <ProgresSpinner
              caption={`We are processing files, please wait...`}
            />
          </div>
        </ModalBody>
      ) : (
        <ModalBody>
          <>
            {isReview ? (
              <>
                {(promotedCustomerFiles?.length > 0 ||
                  promotedFiles?.length > 0 ||
                  promotedFolders?.connector_views?.length > 0 ||
                  promotedFolders.power_distribution?.length > 0 ||
                  promotedFolders.vehicle_views?.length > 0 ||
                  promotedFolders.visual_aid?.length > 0) && (
                  <div className={`pt-2 text-white text-lg border-white`}>
                    {promotedCustomerFiles?.length > 0 && (
                      <>
                        <div>Customer Setup :- </div>
                        <div className="flex flex-row flex-wrap text-white text-lg">
                          {promotedCustomerFiles?.map((key, fileIdx) => {
                            return (
                              <div
                                className="flex w-1/4 py-1"
                                key={`promoted-customer-files-${key}-${fileIdx}`}
                              >
                                <div
                                  className={`px-2 flex items-center w-full`}
                                >
                                  <>
                                    <CheckCircle
                                      size="1rem"
                                      color="text-green-400"
                                      className="text-green-400"
                                    />
                                    <div className="table_text w-auto flex">
                                      <Tooltip message={key}>
                                        <span className="px-2">{key}</span>
                                      </Tooltip>
                                    </div>
                                  </>
                                </div>
                              </div>
                            )
                          })}
                        </div>
                      </>
                    )}
                    {(promotedFiles?.length > 0 ||
                      promotedFolders?.connector_views?.length > 0 ||
                      promotedFolders.power_distribution?.length > 0 ||
                      promotedFolders.vehicle_views?.length > 0 ||
                      promotedFolders.visual_aid?.length > 0) && (
                      <>
                        <div className="text-white text-lg">
                          <div className="py-2 ">
                            <div>Make Model Files :- </div>
                            <div className="flex flex-row flex-wrap text-white text-lg">
                              {promotedFiles?.map((key, fileIdx) => {
                                return (
                                  <div
                                    className="flex w-1/4 py-1"
                                    key={`files-${key}-${fileIdx}`}
                                  >
                                    <div
                                      className={`px-2 flex items-center w-full`}
                                    >
                                      <>
                                        <CheckCircle
                                          size="1rem"
                                          color="text-green-400"
                                          className="text-green-400"
                                        />
                                        <div className="table_text w-auto flex">
                                          <Tooltip message={key}>
                                            <span className="px-2">{key}</span>
                                          </Tooltip>
                                        </div>
                                      </>
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                          </div>

                          <div className="flex flex-row flex-wrap w-full text-white text-lg border-b">
                            {state?.promoteFilesData?.folders &&
                              Object.keys(
                                state?.promoteFilesData?.folders
                              )?.map((key, folderIdx) => {
                                return promotedFolders[key]?.length ? (
                                  <div
                                    className={`flex w-auto py-1 ${section === key && 'bg-tracer-chrome-blue rounded-t border-t border-r border-l'}`}
                                    key={`folder-${key}-${folderIdx}`}
                                  >
                                    <div
                                      className={`px-2 flex `}
                                      onClick={() => {
                                        setSelectAll(false)
                                        if (key === section) {
                                          setSection(null)
                                          setSectionData([])
                                        } else {
                                          setSection(key)
                                          setSectionData([
                                            ...promotedFolders?.[key],
                                          ])
                                        }
                                      }}
                                    >
                                      <>
                                        <RadioButton
                                          name={'section'}
                                          checked={section === key}
                                          onChange={(e) => {
                                            if (e.target.checked) {
                                              setSection(null)
                                              setSectionData([])
                                            } else {
                                              setSection(key)
                                              setSectionData([
                                                ...promotedFolders?.[key],
                                              ])
                                            }
                                          }}
                                          value={section === key}
                                        />
                                        <span className="px-2 cursor-pointer">
                                          {key}
                                        </span>

                                        {key === 'connector_views' && (
                                          <div
                                            className={`flex items-center text-white`}
                                          >
                                            [
                                            <div className="flex items-center px-2">
                                              {includePn ? (
                                                <CheckCircle
                                                  size="1rem"
                                                  color="text-green-400"
                                                  className="text-green-400"
                                                />
                                              ) : (
                                                <CheckboxMinus
                                                  size="1rem"
                                                  color="text-red-400"
                                                  className="text-red-400"
                                                />
                                              )}

                                              <div className="table_text w-auto">
                                                <Tooltip
                                                  message={`Include Part Number`}
                                                >
                                                  <span className="px-2">
                                                    Include Part Number
                                                  </span>
                                                </Tooltip>
                                              </div>
                                            </div>
                                            ]
                                          </div>
                                        )}
                                      </>
                                    </div>
                                  </div>
                                ) : (
                                  <></>
                                )
                              })}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="py-2 text-white text-lg border-b border-white">
                  <div className="flex items-center justify-between">
                    <div>Customer Setup :- </div>
                    <div className="text-lg text-orange-500">
                      ** This files are required if you are promoting new make
                      model.
                    </div>
                  </div>
                  <div className="flex flex-row flex-wrap">
                    {state?.promoteFilesData?.customer_files &&
                      Object.keys(state?.promoteFilesData?.customer_files)?.map(
                        (key, fileIdx) => {
                          return (
                            <div
                              className="flex w-1/4 py-1"
                              key={`customer-files-${key}-${fileIdx}`}
                            >
                              <div className={`px-2 flex items-center w-full`}>
                                <>
                                  <CheckBox
                                    onChange={(e) => {
                                      selectUnSelectFiles(
                                        e?.target?.checked,
                                        key,
                                        'customer_data'
                                      )
                                    }}
                                    checked={promotedCustomerFiles?.includes(
                                      key
                                    )}
                                  />
                                  <div className="table_text w-auto">
                                    <Tooltip message={key}>
                                      <span className="px-2">{key}</span>
                                    </Tooltip>
                                  </div>
                                  {state?.promoteFilesData?.customer_files?.[
                                    key
                                  ]?.is_exists && (
                                    <Save
                                      size="1rem"
                                      color="text-green-400"
                                      className="text-green-400"
                                    />
                                  )}
                                </>
                              </div>
                            </div>
                          )
                        }
                      )}
                  </div>
                </div>

                <div className="text-white text-lg">
                  <div className="py-2 ">
                    <div>Make Model Files :- </div>
                    <div className="flex flex-row flex-wrap text-white text-lg">
                      {state?.promoteFilesData?.files &&
                        Object.keys(state?.promoteFilesData?.files)?.map(
                          (key, fileIdx) => {
                            return (
                              <div
                                className="flex w-1/4 py-1"
                                key={`files-${key}-${fileIdx}`}
                              >
                                <div
                                  className={`px-2 flex items-center w-full`}
                                >
                                  <>
                                    <CheckBox
                                      onChange={(e) => {
                                        selectUnSelectFiles(
                                          e?.target?.checked,
                                          key,
                                          null
                                        )
                                      }}
                                      checked={promotedFiles?.includes(key)}
                                    />
                                    <div className="table_text w-auto">
                                      <Tooltip message={key}>
                                        <span className="px-2">{key}</span>
                                      </Tooltip>
                                    </div>
                                    {state?.promoteFilesData?.files?.[key]
                                      ?.is_exists && (
                                      <Save
                                        size="1rem"
                                        color="text-green-400"
                                        className="text-green-400"
                                      />
                                    )}
                                  </>
                                </div>
                              </div>
                            )
                          }
                        )}
                    </div>
                  </div>
                  <div className="flex text-white text-lg w-full border-b">
                    {state?.promoteFilesData?.folders &&
                      Object.keys(state?.promoteFilesData?.folders)?.map(
                        (key, folderIdx) => {
                          return (
                            <div
                              className={`flex w-auto py-1 items-center ${section === key && 'bg-tracer-chrome-blue rounded-t border-t border-r border-l'}`}
                              key={`folder-${key}-${folderIdx}`}
                            >
                              <div
                                className={`px-2 flex `}
                                onClick={() => {
                                  setSelectAll(false)
                                  if (key === section) {
                                    setSection(null)
                                    setSectionData([])
                                  } else {
                                    setSection(key)
                                    setSectionData([
                                      ...state?.promoteFilesData
                                        ?.section_data?.[key],
                                    ])
                                  }
                                }}
                              >
                                <div className="flex items-center gap-1">
                                  <RadioButton
                                    name={'section'}
                                    checked={section === key}
                                    onChange={(e) => {
                                      selectUnSelectSection(
                                        key,
                                        e.target.checked
                                      )
                                    }}
                                    value={section === key}
                                  />
                                  <span className="cursor-pointer">{key}</span>

                                  {key === 'connector_views' && (
                                    <div
                                      className={`flex items-center text-white gap-1`}
                                    >
                                      [
                                      <div className="flex items-center">
                                        <CheckBox
                                          onChange={(e) => {
                                            setIncludePn(e?.target?.checked)
                                          }}
                                          checked={includePn}
                                        />
                                        <div
                                          className="table_text w-auto"
                                          onClick={() => {
                                            setIncludePn(!includePn)
                                          }}
                                        >
                                          <Tooltip
                                            message={`Include Part Number`}
                                          >
                                            <span className="px-2">
                                              Include Part Number
                                            </span>
                                          </Tooltip>
                                        </div>
                                      </div>
                                      ]
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          )
                        }
                      )}
                  </div>
                </div>
              </>
            )}
            {section && (
              <div className="bg-tracer-chrome-blue pb-3 border-white rounded-b border-r border-l border-b">
                <div className="border-b  border-white mb-3">
                  <div
                    className={`flex justify-between items-center text-white ${isReview ? 'px-2' : 'pr-2'}`}
                  >
                    {!isReview && (
                      <div className="px-2 flex items-center w-full">
                        <div className={`flex w-1/2`}>
                          <CheckBox
                            onChange={(e) => {
                              setSelectAll(e?.target?.checked)
                              selectAllValues(e?.target?.checked)
                            }}
                            checked={
                              selectAll ||
                              sectionData?.length ==
                                promotedFolders?.[section]?.length
                            }
                          />
                          <span className="px-2">Select All</span>
                        </div>
                      </div>
                    )}

                    <InputText
                      name="search_value"
                      placeholder={`Search ${section} ....`}
                      className={`w-auto`}
                      value={searchValue}
                      isFullSize={true}
                      type="search"
                      onChange={(value) => {
                        setSearchValue(value)
                      }}
                      isRequired={false}
                      wrapperClass={`pl-0`}
                    />
                    <span
                      className="text-3xl cursor-pointer"
                      onClick={() => {
                        setSection(null)
                      }}
                    >
                      &times;
                    </span>
                  </div>
                </div>
                <div
                  className="relative overflow-y-scroll "
                  style={{ maxHeight: '25vh' }}
                >
                  <div className="flex flex-row flex-wrap text-white  text-base ">
                    {filteredData
                      .sort()
                      .slice(
                        0,
                        isReview ? filteredData?.length : filteredData?.length
                      )
                      .map((filterRow, filterRowIdx) => {
                        return (
                          <div
                            className="flex w-1/4 py-1"
                            key={`section-${filterRowIdx}`}
                          >
                            <div className={`px-2 flex w-full items-center`}>
                              {isReview ? (
                                <CheckCircle
                                  size="1rem"
                                  color="text-green-400"
                                  className="text-green-400"
                                />
                              ) : (
                                <CheckBox
                                  onChange={(e) => {
                                    selectUnSelectFiles(
                                      e?.target?.checked,
                                      filterRow,
                                      section
                                    )
                                  }}
                                  checked={promotedFolders?.[section]?.includes(
                                    filterRow
                                  )}
                                />
                              )}

                              <div className="table_text w-3/4">
                                <Tooltip message={filterRow}>
                                  <span className="px-2">{filterRow}</span>
                                </Tooltip>
                              </div>
                            </div>
                          </div>
                        )
                      })}
                    {sectionData?.length === 0 && <NoRecordsFound />}
                  </div>
                </div>
              </div>
            )}
            {responseData?.data?.upload_status ? (
              <></>
            ) : (
              <div className="flex flex-row flex-wrap justify-end my-2 gap-3 w-full">
                {isReview ? (
                  <>
                    <div className="flex flex-row flex-wrap justify-between w-full items-center">
                      <div className="flex items-center gap-2">
                        {section && (
                          <div className="text-white">
                            Total {section} Records :- {sectionData?.length}
                          </div>
                        )}
                      </div>

                      <div className="flex gap-3 items-center">
                        {navState?.permissions?.includes(PUSH_TO_GIT) && (
                          <div className="flex items-center text-white gap-3">
                            <CheckBox
                              onChange={(e) => {
                                setSyncToGit(e?.target?.checked)
                              }}
                              checked={syncToGit}
                            />

                            <span>Sync To Git</span>
                          </div>
                        )}

                        <Button
                          type="submit"
                          className={`cursor-pointer btn`}
                          text={'Re Select Files'}
                          onClick={() => {
                            setReview(false)
                            setSection(null)
                            setSectionData([])
                          }}
                        />
                        <Button
                          type="submit"
                          className={`cursor-pointer btn`}
                          text={'Confirm & Submit'}
                          onClick={() => {
                            submitReviewedData()
                          }}
                        />
                      </div>
                    </div>
                    <div className="text-center w-full">
                      {promotedFiles?.length < 1 &&
                        promotedFolders?.connector_views?.length < 1 &&
                        promotedFolders.power_distribution?.length < 1 &&
                        promotedFolders.vehicle_views?.length < 1 &&
                        promotedFolders.visual_aid?.length < 1 && (
                          <div className="text-lg text-orange-500">
                            You haven't selected any files but still, if you
                            want to sync last selected data to git you click to
                            review and check sync to git and submit it.
                          </div>
                        )}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="flex justify-between w-full items-center">
                      <div className="flex items-center gap-2">
                        {section && (
                          <div className="text-white">
                            Total {section} Selected :-{' '}
                            {promotedFolders?.[section]?.length}
                          </div>
                        )}
                      </div>

                      <Button
                        type="submit"
                        className={`cursor-pointer btn`}
                        text={'Review'}
                        onClick={() => {
                          clickToReview()
                        }}
                      />
                    </div>
                    <div className="w-full text-center">
                      {promotedCustomerFiles?.length < 0 &&
                        promotedFiles?.length < 1 &&
                        promotedFolders?.connector_views?.length < 1 &&
                        promotedFolders.power_distribution?.length < 1 &&
                        promotedFolders.vehicle_views?.length < 1 &&
                        promotedFolders.visual_aid?.length < 1 && (
                          <div className="text-lg text-orange-500">
                            You haven't selected any files but still, if you
                            want to sync last selected data to git you click to
                            review and check sync to git and submit it.
                          </div>
                        )}
                    </div>{' '}
                  </>
                )}
              </div>
            )}
          </>
        </ModalBody>
      )}
    </Modal>
  )
}

export default SelectFileToPromote
